<template>  
  <q-page padding class="dialog">
    <q-btn
        icon="cached"
        color="primary"
        :label="gpsButtonText"
        @click="getGps()">
        <q-chip v-if="gpsPosition" floating :color="gpsColor">{{$t('global.Meter')}}: {{ Math.round(gpsPosition.accuracy) }}</q-chip>
    </q-btn>
    <q-datetime v-model="startTime" type="datetime" :float-label="$t('global.WorkStart')" format="D.MMM.YYYY HH:mm" />
    <p class="timer text-weight-bold">{{ timeElapsed }}</p>
    <q-card class="dialog"> 
      <div>
        <div v-if="recordingTime == false">{{$t('global.Assigned')}} <q-toggle v-model="allWork" :label="$t('global.All')" /></div>
        <div v-if="allWork == false" name="tab-assigned">
          <q-select 
            v-model="selectAssignedWork"
            :float-label="$t('global.AssignedWork')"
            :options="assignedWorkOptions"
            @input="workChanged('assigned')"
            v-show="!assignedWorkInProgress"
          />
          <div v-if="selectAssignedWork">
            <q-input class="comment" v-model="assignedWorkText" rows="2" :float-label="$t('global.Comment')" type="textarea" />
            <p></p>       
            <p class="text-weight-bold">{{ assignedWork[selectAssignedWork].geoRegionDescription + ', ' +  assignedWork[selectAssignedWork].resourceDescription}}</p>
          </div>
          <div v-if="selectAssignedWork && !assignedWorkInProgress" class="row">
            <div class="col-8" v-if="assignedWork[selectAssignedWork].flexPriceResource && assignedWork[selectAssignedWork].workCount == 0">
              <q-input v-model="flexPrice" type="number" mask="#.##" :stack-label="'Kosten - ' + assignedWork[selectAssignedWork].flexPriceResource" />
              <br>
            </div>
            <q-btn class="dialog" color="positive" @click="WorkStart('assigned')">{{$t('global.TakeOrder')}}</q-btn>
          </div>
          <div v-if="assignedWorkInProgress">
            <q-btn class="dialog" color="positive" @click="WorkEnd('Stop')" >{{$t('global.Pause')}}</q-btn>
            &nbsp;
            <q-btn class="dialog" color="positive" @click="WorkEnd('End')" >{{$t('global.Done')}}</q-btn>
          </div>
        </div>
        <div  v-if="allWork == true"  name="tab-all">
          <q-select
            v-model="selectGeofence"
            :float-label="$t('global.SelectGeoRegion')"
            :options="selectOptions"
            v-show="!workInProgress"
          />
          <q-select
            v-model="idProduct"
            :float-label="$t('global.Product')"
            :options="optionsProduct"  
            ref="selProducts" 
          />  
          <q-card v-show="!workInProgress">  
            <q-collapsible :label="selectWorkLabel" v-model="workOpend">
              <q-tree
                :nodes="workTree" 
                node-key="IdResource"
                :selected.sync="selectedWork"
                :expanded.sync="propsExpandedWork"
              />
            </q-collapsible>
          </q-card>
          <p></p>
          <q-input class="comment" v-model="workText" rows="2" :float-label="$t('global.Comment')" type="textarea" />
          <p></p>
          <div>
            <p>
              <span  v-if="selectGeofence" class="text-weight-bold">{{ geoRegion[selectGeofence].geoRegionDescription }}</span>
              <span  v-if="!selectGeofence" >{{$t('global.SelectGeoRegion')}}</span>
              <span> - </span>
              <span  v-if="selectedWork" class="text-weight-bold" >{{workTreeFlat[selectedWork].Label}}</span>
              <span  v-if="!selectedWork" >{{$t('global.SelectWork')}}</span>
            </p>

            <div class="col-8" v-if="workTreeFlat[selectedWork] && workTreeFlat[selectedWork].flexPriceResource && !workInProgress">
              <q-input v-model="flexPrice" type="number" mask="#.##" :stack-label="'Kosten - ' + workTreeFlat[selectedWork].flexPriceResource" />
              <br>
            </div>

            <q-btn :disable="!selectGeofence || !selectedWork" class="dialog" color="positive" @click="WorkStart('work')" v-if="!workInProgress">{{$t('global.StartWork')}}</q-btn>
          </div> 
          <div v-if="workInProgress">
        <q-btn class="dialog" color="positive" @click="WorkEnd('Stop')" >{{$t('global.Finish')}}</q-btn>
      </div>
     </div>   
    </div>   
    <p></p>
    </q-card> 
  </q-page>
</template>

<script>
import { openURL } from 'quasar'
import { eventBus } from '../main'
import { date } from 'quasar'
import axios from 'axios'
import qs from 'qs'

export default {
  name: 'SideDialog1',
  data () {
    return {
      assignedWorkInProgress: false,
      workInProgress: false,
      workTree: [],
      workTreeFlat: [],
      selectedWork: null,
      propsExpandedWork: [],
      selectedTab: 'tab-assigned',
      assignedWorkSelection: true,
      assignedWork: [],
      geoRegion: [],
      selectAssignedWork: null,
      selectWork: null,
      selectGeofence: null,
      gpsButtonText: this.$t('global.GpsPosition'),
      gpsPosition: null,
      gpsColor: 'positive',
      startTime: new Date(),
      workText: '',
      assignedWorkText: '',
      form: {
        SessionId: null,
      },
      selectOptions: [],
      assignedWorkOptions: [],
      workOpend: false,
      timeElapsed: '00:00:00',
      interval: null, 
      allWork: false, 
      recordingTime: false,
      idProduct: 0,
      optionsProduct: [],
      flexPrice: 0.00,
    }
  },
  mounted() {
    
  },
  created () {
    eventBus.$on('WorkAssignUpdate', (data) => {
      this.getGps()
    })
  },
  activated() {
    if(!this.workInProgress){
      this.startTime = new Date()
      this.getGps()
    }
  },
  methods: {
    getGps (){
      this.loadResourceTree()
      var options = {
        enableHighAccuracy: true,
        timeout: 5000,
        maximumAge: 0
      }

      if(navigator.geolocation){
        navigator.geolocation.getCurrentPosition(position => {
          //this.positions.push(position.coords);
          this.gpsPosition = position.coords
          this.gpsButtonText = this.$t('global.Update') + ' / ' + this.$t('global.GpsPosition')
          
          if(position.coords.accuracy >= 20)
            this.gpsColor = 'negative'
          else
            this.gpsColor = 'positive'

          var latitude = position.coords["latitude"]
          var longitude = position.coords["longitude"]
          
          console.log(position)

          var latitude = position.coords.latitude
          var longitude = position.coords.longitude

          eventBus.$emit('showCurrentGpsPosition',{ latlong: [latitude, longitude], label: "My Position" })
          this.loadGeoRegions({ lat: latitude, long: longitude })
          this.loadAssignedWork({ lat: latitude, long: longitude })
        }, this.gpsError, options)
      }
       else {
         alert("Geolocation is not supported by this browser.")
      }
    },
    WorkStart (type) {
      this.form.SessionId = this.$store.state.session.SessionId

      if(this.gpsPosition != null){ 
        this.form.position = {accuracy: this.gpsPosition.accuracy, latitude: this.gpsPosition.latitude, longitude: this.gpsPosition.longitude }
      }
      this.form.Starting = this.startTime
      this.workInProgress = true
      
      if(type == 'assigned'){
          this.form.action = 'AssignedWorkStart'
          this.form.IdWorkAssign = this.selectAssignedWork
          this.assignedWorkInProgress = true
          this.form.Comment = this.assignedWorkText
          
          if(this.assignedWork[this.selectAssignedWork].flexPriceResource  &&  this.assignedWork[this.selectAssignedWork].workCount == 0){
            this.form.FlexPrice = this.flexPrice
          }
          else{
            this.form.FlexPrice = null
          }
      }

      if(type == 'work'){
          this.form.action = 'WorkStart'
          this.form.IdResource = this.selectedWork
          this.form.IdGeoRegion = this.selectGeofence
          this.form.Comment = this.workText
          this.form.IdProdcut = this.idProduct
          if(this.workTreeFlat[this.selectedWork].flexPriceResource){
            this.form.FlexPrice = this.flexPrice
          }
          else{
            this.form.FlexPrice = null
          }
      }

      axios.post(this.$apiUrl,
      qs.stringify(this.form),
      {
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
      })
      .then(response => {
          var self = this;
          this.submitting = false
          console.log(response.data)
          console.log(response)
          if(response.status == 200){ 
              if(!isNaN(response.data)){
                this.IdWork = response.data
                this.$q.notify({ message: this.$t('global.WorkStarted'), type: 'positive' })
                //eventBus.$emit('workChange', null)
                this.recordingTime = true
                this.setTimer(true)
              }
              else{
                this.$q.notify('ERROR')
              }
          }
          else{
              this.$q.notify('ERROR')
          }
      })
      .catch(e => {
          this.submitting = false
          if(e.response.status == 403){
              //this.errors.push(this.translate('LoginError'))
              this.$q.notify('ERROR')

          }
          console.log(e)
      })  
    },
    WorkEnd (type) {
      //send end work to server
      this.form.IdWork = this.IdWork
      this.form.SessionId = this.$store.state.session.SessionId

      this.form.action = 'WorkStop'

      if(type == 'End')
        this.form.done = true
      else
        this.form.done = false

      //if(this.selectedTab == 'tab-all'){
      if(this.allWork){
        this.form.Comment = this.workText  
      }
      else{
        this.form.Comment = this.assignedWorkText
      }

      
      axios.post(this.$apiUrl,
      qs.stringify(this.form),
      {
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
      })
      .then(response => {
          this.submitting = false
          console.log(response.data)
          console.log(response)
          if(response.status == 200){ 
            this.assignedWorkInProgress = false
            this.workInProgress = false
            this.setTimer(false)
            this.timeElapsed = '00:00:00'
            this.startTime = new Date()
            this.recordingTime = false
            this.$q.notify({ message: this.$t('global.WorkEnded'), type: 'positive' })
            eventBus.$emit('workChange', null)
            //eventBus.$emit('closeDialog', null)
            this.workText = ''
            this.assignedWorkText = ''
            this.getGps()
            this.startTime = new Date()
            if(type == 'End'){
              this.selectAssignedWork = null
              this.selectGeofence = null
              this.workText = ''
            } 
            this.$router.push({name: 'Journal'})
          }
          else{
              this.$q.notify('ERROR')
          }
      })
      .catch(e => {
          this.submitting = false
            this.$q.notify(this.$t('global.NoConnection'))
            this.$q.notify('status: ' + e.response.status)
          console.log(e)
      }) 
    },
    workChanged (T) {
      if(T == 'assigned'){
        this.selectGeneralWork = null
        this.selectWork = this.selectAssignedWork
        this.assignedWorkText = ''
        if(this.assignedWork[this.selectAssignedWork].workCount == 0){
            this.assignedWorkText = this.assignedWork[this.selectAssignedWork].flexPriceResource
        }
      }
      else{
        this.selectAssignedWork = null
        this.selectWork = this.selectGeneralWork
      }
    },
    loadGeoRegions(position){
      this.form.SessionId = this.$store.state.session.SessionId
      this.form.action = 'GeoRegionsSelect'
      this.form.position = position
      axios.post(this.$apiUrl,
      qs.stringify(this.form),
      {
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
      })
      .then(response => {
          var self = this;
          this.submitting = false
          console.log(response.data)
          console.log(response)
          if(response.status == 200){ 
              this.selectOptions = []   
              response.data.forEach(GeoRegion => {
                  this.selectOptions.push({label: GeoRegion.Description + ', ' + GeoRegion.Distance + ' M', value: GeoRegion.IdGeoRegion}) 
                  this.geoRegion[GeoRegion.IdGeoRegion] = { geoRegionDescription: GeoRegion.Description }
              });
          }
          else{
              this.$q.notify('ERROR')
          }
      })
      .catch(e => {
          this.submitting = false
          if(e.response.status == 403){
              //this.errors.push(this.translate('LoginError'))
              this.$q.notify('ERROR')

          }
          console.log(e)
      })

    },
    loadResourceTree(){
      this.form.SessionId = this.$store.state.session.SessionId
      this.form.action = "getResourceTree"
      this.form.OnlyWorkSelectable = true
      axios.post(this.$apiUrl,
      qs.stringify(this.form),
      {
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
      })
      .then(response => {
          this.submitting = false
          if(response.status == 200){ 
              //this.propsExpanded.push(response.data[0].IdGeoRegion) //Open expand first node
              this.workTree = response.data
              this.makeWorkTreeFlat(response.data)
          }
          else{
              this.$q.notify('ERROR')
          }
      })
      .catch(e => {
        this.$q.notify('ERROR')
        console.log(e);
      })
    },
    loadAssignedWork(position){
      this.form.SessionId = this.$store.state.session.SessionId
      this.form.action = 'GetWorkAssignSelect'
      this.form.position = position
      axios.post(this.$apiUrl,
      qs.stringify(this.form),
      {
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
      })
      .then(response => {
          var self = this;
          this.submitting = false
          console.log(response.data)
          console.log(response)
          if(response.status == 200){ 
              this.assignedWorkOptions = []            
              response.data.forEach(Work => {
                  var Product ='<br>' + this.$t('global.Product') + ': ' + this.$t('global.All')
                  if (Work.IdProduct != null)
                    Product ='<br>' + this.$t('global.Product') + ': ' + Work.Product
                  
                  Product += '<br>' + Work.Comment
                  this.assignedWorkOptions.push({ label: Work.GeoRegionDescription + ' ' +  Work.Distance + 'M' + '<br>' + Work.ResourceDescription + Product, value: Work.IdWorkAssign  })
                  this.assignedWork[Work.IdWorkAssign] = { geoRegionDescription: Work.GeoRegionDescription, comment: Work.Comment, resourceDescription: Work.ResourceDescription, flexPriceResource: Work.FlexPriceResource, workCount: Work.WorkCount }
              });
          }
          else{
              this.$q.notify('ERROR')
          }
      })
      .catch(e => {
          this.submitting = false
          if(e.response.status == 403){
              //this.errors.push(this.translate('LoginError'))
              this.$q.notify('ERROR')

          }
          console.log(e)
        })
      },

    makeWorkTreeFlat(elements){ 
      elements.forEach(element => {
        this.workTreeFlat[element.IdResource] = { Label: element.label, Icon: element.icon, flexPriceResource: element.FlexPriceResource }
        //recursive call:
        this.makeWorkTreeFlat(element.children)
      })
    },
    setTimer(on) {
     
      if (!on) {
        clearInterval(this.interval);
      } else {
        this.interval = setInterval(this.incrementTime, 1000);
      }    
    },
    incrementTime() {
      
      //this.seconds = parseInt(this.seconds) + 1;
      var seconds = date.getDateDiff(new Date(), this.startTime, 'seconds')
      this.timeElapsed = Math.floor(this.moment.duration(seconds,'seconds').asHours()) + ':' + this.moment.duration(seconds,'seconds').minutes() + ':' + this.moment.duration(seconds,'seconds').seconds(); 
      
    },
    gpsError(err) {
      console.log(`ERROR(${err.code}): ${err.message}`);
      this.$q.notify(this.$t('global.GpsError'))
      this.loadNoGps()
    },
    loadNoGps(){
      this.loadGeoRegions({ lat: 0, long: 0 })
      this.loadAssignedWork({ lat: 0, long: 0 })
    },

    loadProduct(){
        this.form.SessionId = this.$store.state.session.SessionId
        this.form.IdGeoRegion = this.selectGeofence
        this.form.action = "listProductByGeoRegion"
        axios.post(this.$apiUrl,
        qs.stringify(this.form),
        {
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
        })
        .then(response => {
            console.log(response)
            if(response.status == 200){ 
              this.optionsProduct = [] 
              this.optionsProduct.push({ value: 0, label: this.$t('global.All') })
              response.data.forEach(product => {
                this.optionsProduct.push(product)
              })
            }
            else{
                this.$q.notify('Something Wrong.')
            }
        })
        .catch(e => {        
          this.$q.notify('Something Wrong.')      
          console.log(e);
        })
    },
  },
  watch: {
    selectedWork: function (newWork, oldWork) {
      //Close Work selection when selected
      if(newWork != null)
        if(this.workTreeFlat[newWork].Icon == 'block'){
          this.$q.notify('Kann nur per Auftrag zugeteilt werde, da Ressource Kosten per Auftrag definiert sind.')
        }
        else{
          if(this.workTreeFlat[newWork].Icon == 'highlight_off'){
            this.$q.notify('Kann nicht verwendet werden, da Arbeit mehr als eine Ressource mit flexiblen Kosten zugeteilt.')
          }
          else{
            this.workOpend = false
          } 
        }  
        if(this.workTreeFlat[this.selectedWork].flexPriceResource != null){
            this.workText = this.workTreeFlat[this.selectedWork].flexPriceResource
        } 
    },
    selectGeofence: function (newWork, oldWork) {
          this.loadProduct()
    },

  },
  computed: {
    selectWorkLabel: function () {
      if(this.selectedWork != null)
        return this.workTreeFlat[this.selectedWork].Label
      else
        return this.$t('global.SelectWork') 
    }
  },
}



</script>

<style scoped>
.dialog{
        padding: 10px;
        
    }
.comment{
  background-color:lightgray;
}
.timer{
  text-align: center;
  padding-top: 10px;
}
</style>
